import { axios } from "@/core/axios";
import { ProfilePayload, UpdateProfileResponse } from "./types";
import { STORAGE_KEY_PREFIX } from "@/modules/auth";

export const profileEndpoints = {
    updateProfile: async (updates: Partial<ProfilePayload>): Promise<UpdateProfileResponse | undefined> => {
        const mapToken = localStorage.getItem(`${STORAGE_KEY_PREFIX}.mapToken`);
        const response = await axios.put<UpdateProfileResponse>(`/profile`, { ...updates, mapToken });
        return response.data;
    },
};
